import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from '@shopify/app-bridge-react';
import App from './App';
import './index.css';
import { parseShopContext } from './utils/shopContext';

const apiKey = import.meta.env.VITE_SHOPIFY_API_KEY || '';
const { shop, host } = parseShopContext();
const shopifyHost = host || '';

// Production: require apiKey - show clear error if missing
const isProduction = import.meta.env.MODE === 'production';
if (isProduction && !apiKey) {
  const root = document.getElementById('root')!;
  root.innerHTML = `
    <div style="font-family: system-ui, sans-serif; max-width: 480px; margin: 80px auto; padding: 24px; text-align: center;">
      <h1 style="color: #1a1a1a; font-size: 20px; margin-bottom: 16px;">Configuration Error</h1>
      <p style="color: #666; line-height: 1.6;">
        VITE_SHOPIFY_API_KEY is required in production. Add it to your Cloudflare Pages environment variables.
      </p>
      <p style="color: #888; font-size: 14px; margin-top: 24px;">
        Rebuild and deploy after setting the variable.
      </p>
    </div>
  `;
} else {
  // appOrigins is a v4-only config option and not valid for app-bridge-react v3 Provider.
  // The v3 Provider only accepts: apiKey, host, forceRedirect.
  const appBridgeConfig =
    shopifyHost && apiKey
      ? {
          apiKey,
          host: shopifyHost,
          forceRedirect: isProduction,
        }
      : null;

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      {appBridgeConfig ? (
        <Provider config={appBridgeConfig}>
          <App />
        </Provider>
      ) : (
        <App />
      )}
    </React.StrictMode>
  );
}
